import React, { Dispatch, SetStateAction, useMemo, useState } from 'react';

type StageContextValue = {
  videoPlayerOpen: boolean;
  setVideoPlayerOpen: Dispatch<SetStateAction<boolean>>;
  webstreamLayerOpen: boolean;
  setWebstreamLayerOpen: Dispatch<SetStateAction<boolean>>;
  webstreamScriptLoading: boolean;
  setWebstreamScriptLoading: Dispatch<SetStateAction<boolean>>;
  videoUrl: string;
};

const initialStageContext = {
  videoPlayerOpen: false,
  setVideoPlayerOpen: () => {},
  webstreamLayerOpen: false,
  setWebstreamLayerOpen: () => {},
  webstreamScriptLoading: false,
  setWebstreamScriptLoading: () => {},
  videoUrl: '',
};

export const StageContext = React.createContext<StageContextValue>(initialStageContext);

type StageContextProviderProps = React.PropsWithChildren & {
  videoUrl: string;
};

export const StageContextProvider: React.FC<StageContextProviderProps> = ({
  videoUrl,
  children,
}) => {
  const [videoPlayerOpen, setVideoPlayerOpen] = useState(false);
  const [webstreamLayerOpen, setWebstreamLayerOpen] = useState(false);
  const [webstreamScriptLoading, setWebstreamScriptLoading] = useState(false);

  const stageContextValue: StageContextValue = useMemo(() => {
    return {
      videoPlayerOpen,
      webstreamLayerOpen,
      setVideoPlayerOpen,
      setWebstreamLayerOpen,
      webstreamScriptLoading,
      setWebstreamScriptLoading,
      videoUrl,
    };
  }, [videoPlayerOpen, webstreamLayerOpen, webstreamScriptLoading, videoUrl]);

  return <StageContext.Provider value={stageContextValue}>{children}</StageContext.Provider>;
};
